export default __webpack_public_path__ + "static/media/upArrow.796036b6.svg";